import { useDeviceState } from '@/hooks/store';
import { useAmplitudeExperiment } from '@/hooks/utils/experiments/useAmplitudeExperiment';
import { AmplitudeExperimentNames } from '@/utils/experiments/amplitudeExperiment';

import type { TruemedPlan } from './truemedApi';

const TRUEMED_PLANS: readonly string[] = ['monthly', 'quarterly', 'yearly'];

function isTruemedPlan(plan: string | undefined): plan is TruemedPlan {
	return plan !== undefined && TRUEMED_PLANS.includes(plan);
}

// `enabled: false` short-circuits the experiment lookup so surfaces that never offer Truemed
// don't evaluate (and get counted as exposed to) the experiment.
export function useTruemedEligibility(
	plan: string | undefined,
	enabled = true,
): {
	isEligible: boolean;
	isLoading: boolean;
	plan: TruemedPlan | null;
} {
	const { isEnrolled, isLoading } = useAmplitudeExperiment(
		AmplitudeExperimentNames.TRUEMED_PAYMENT,
		!enabled,
	);

	const { ip_country: ipCountry } = useDeviceState();

	const truemedPlan = isTruemedPlan(plan) ? plan : null;
	const isEligible = enabled && !isLoading && !!isEnrolled && ipCountry === 'us' && truemedPlan !== null;
	return { isEligible, isLoading, plan: truemedPlan };
}
